import SignaturePad from "signature_pad";

const sigPads = {};

function initializeCanvas() {
  document.querySelectorAll("canvas").forEach(function (sig) {
    if (sig.dataset.sigpadBound) return;
    sig.dataset.sigpadBound = "1";

    const formKey = $(sig).closest("form").data("form-key");
    const pad = new SignaturePad(sig);
    if (formKey) sigPads[formKey] = pad;

    $(sig)
      .siblings(".clear")
      .click(function (event) {
        event.preventDefault();
        pad.clear();
      });
  });

  resizeCanvas();
}

function resizeCanvas() {
  document.querySelectorAll("canvas").forEach(function (sig) {
    const width = sig.clientWidth;
    const height = sig.clientHeight;

    if (sig.width !== width || sig.height !== height) {
      sig.width = width;
      sig.height = height;
    }
  });
}

window.addEventListener("resize", resizeCanvas);
$(document).on("shown.bs.tab", '.nav-tabs a, [data-toggle="pill"]', resizeCanvas);
$(document).on("bp:remote-content-loaded", function () {
  initializeCanvas();
  bindIntakeFormSubmits();
});

function setSigPad(form) {
  var sigPad = sigPads[form.data("form-key")];
  if (sigPad) form.find(".empty-signature").hide();
  return sigPad || false;
}

function submitIntakeForm(form, sigPad, requestType, event) {
  form.find(".intake-form-alert").addClass("d-none");

  if (form[0].checkValidity() === false) {
    form[0].classList.add("was-validated");
    form.find(".intake-invalid-notification").removeClass("d-none");

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    return;
  }

  form.find(".submit").prop("disabled", true);
  form.find(".submit").html("Saving...");

  if (sigPad && sigPad.isEmpty()) {
    form.find(".empty-signature").show();

    setTimeout(function () {
      form.find(".submit").prop("disabled", false).html("Submit");
    }, 150);

    if (event) event.stopPropagation();
    return false;
  }

  var submitURL = form.find(".submit").data("url");
  var redirectURL = form.find(".submit").data("redirect-url");
  var portalResponseId = form.data("intakeResponseId");
  var formData = new FormData(form[0]);

  if (sigPad) {
    var signatureB64 = sigPad.toDataURL();
    formData.append("signature", signatureB64);
  }

  var xhr = new XMLHttpRequest();
  xhr.open(requestType, submitURL);
  xhr.setRequestHeader("Accept", portalResponseId ? "application/json" : "text/javascript");
  xhr.send(formData);

  xhr.onreadystatechange = function () {
    if (this.readyState == 4 && this.status == 200) {
      if (portalResponseId) {
        handlePortalIntakeSuccess(form, this.response);
        return;
      }
      if (typeof redirectURL !== "undefined") {
        window.location.replace(redirectURL);
      } else {
        var response = this.response;
        var json = JSON.parse(response);
        window.location.replace(json.redirect_url);
      }
    } else if (this.readyState == 4) {
      form.find(".intake-form-alert").removeClass("d-none");
      form.find(".submit").prop("disabled", false);
      form.find(".submit").html("Submit");
    }
  };
}

function handlePortalIntakeSuccess(form, rawResponse) {
  var json;
  try {
    json = JSON.parse(rawResponse);
  } catch (e) {
    json = {};
  }

  var responseId = json.response_id || form.data("intakeResponseId");
  var reloadUrl = json.reload_url;

  var navLink = document.querySelector(
    '.docs-intake-list .nav-link[data-target="#intake-response-' + responseId + '"]'
  );
  if (navLink) {
    var badge = navLink.querySelector(".badge");
    if (badge) {
      badge.className = "badge badge-success";
      badge.innerHTML = '<i class="far fa-check mr-1"></i>Done';
    }

    var wrapper = navLink.closest(".docs-intake-wrapper");
    var dropdownBadge = wrapper && wrapper.querySelector(".docs-intake-dropdown-badge");
    if (dropdownBadge && navLink.classList.contains("active")) {
      dropdownBadge.className = "docs-intake-dropdown-badge badge badge-success";
      dropdownBadge.innerHTML = '<i class="far fa-check mr-1"></i>Done';
    }
  }

  var pane = document.getElementById("intake-response-" + responseId);
  if (pane && reloadUrl) {
    pane.innerHTML =
      '<div data-controller="load-remote-content" data-load-remote-content-url-value="' +
      reloadUrl +
      '"><p class="text-center p-4 pt-5"><i class="fad fa-spinner-third fa-spin text-secondary mb-3 fa-2x"></i></p></div>';
  }
}

function bindIntakeFormSubmits() {
  document.querySelectorAll("form.js-intake-submit").forEach(function (formEl) {
    if (formEl.dataset.intakeSubmitBound) return;
    formEl.dataset.intakeSubmitBound = "1";

    formEl.addEventListener("submit", function (event) {
      event.preventDefault();

      var form = $(formEl);
      var method = form.find(".submit").data("method");
      var sigPad = setSigPad(form);
      submitIntakeForm(form, sigPad, method, event);
    });
  });
}

$(document).on("turbolinks:load", function () {
  initializeCanvas();
  bindIntakeFormSubmits();

  if ($("#client-forms-and-contracts").is("*")) {
    function handleSignatureBeforeSubmit(form, sigPad) {
      form.find(".intake-form-alert").addClass("d-none");

      if (sigPad && sigPad.isEmpty()) {
        form.find(".empty-signature").show();

        setTimeout(function () {
          form.find(".submit").prop("disabled", false).html("Submit");
        }, 150);

        return false;
      } else if (sigPad) {
        var signatureB64 = sigPad.toDataURL();
        $("#signature").val(signatureB64);
      }
    }

    $("form").submit(function (event) {
      event.preventDefault();

      var form = $(this);
      var sigPad = setSigPad(form);
      handleSignatureBeforeSubmit(form, sigPad);

      if ($(".empty-signature").is(":visible")) {
        setTimeout(function () {
          form.find(".submit").prop("disabled", false).html("Submit");
        }, 150);

      } else {

        if (form.find('.submit').data('verified') == true) {
          submitIntakeForm(form, sigPad, 'POST');
        } else {
          $.ajax({
            url: form.data('captcha'),
            type: "POST",
            beforeSend: function(xhr) {
              xhr.setRequestHeader('X-CSRF-Token', localStorage.getItem("bp-x-csrf-token"));
            },
            dataType: 'json',
            success: function(response) {
              if (response.recaptcha_valid == true) {
                submitIntakeForm(form, sigPad, 'POST');
              } else {
                form.find(".submit").prop("disabled", false).html("Confirm CAPTCHA");

                $.ajax({
                  url: form.data('reload'),
                  type: "GET",
                  beforeSend: function(xhr) {
                    xhr.setRequestHeader('X-CSRF-Token', localStorage.getItem("bp-x-csrf-token"));
                  },
                  dataType: 'script',
                  success: function(response) {
                    console.log('reloading captcha');
                  },
                  error: function() {
                    window.notyf.error(
                      'Server error. Please try again.'
                    );
                    form.find(".submit").prop("disabled", false).html("Submit");
                  }
                });
              }
            },
            error: function() {
              window.notyf.error(
                `Sorry, there was a server error when submitting this form. Please try again.`
              );
              form.find(".submit").prop("disabled", false).html("Submit");
            }
          });

        }
      }
    });
  }

  $("body").on('change', '.js-pet-name-field', function(e){
    var nameInput = $(this);
    var tabId = nameInput.parents('.tab-pane').attr('id');
    var list = $('ul.js-pet-tab-nav');
    var tabLink = list.find('li a[href*="#' + tabId + '"]')

    tabLink.html(nameInput.val());
  });

  $("body").on('click', '.js-add-pet-tab', function(e){
    e.preventDefault();
    var addTabButton = $(this);
    var list = addTabButton.parents('ul.nav-tabs');
    var nonVisible = list.find('li.nav-item.d-none');
    var firstElement = nonVisible.first();
    var tab = $(firstElement.find('a').attr('href'));

    tab.find('input, select, textarea').prop('disabled', false);
    $('.selectpicker').selectpicker('refresh');

    firstElement.removeClass('d-none');
    firstElement.find('a').trigger('click');
    firstElement.find('a').trigger('focus');

    setTimeout(function(){
      addTabButton.removeClass('active');
      firstElement.find('a').addClass('active');
    }, 200)

    if (nonVisible.length === 1) {
      addTabButton.parents('li').hide();
    }
  });

  $("body").on('click', '.js-remove-pet-tab', function(e){
    e.preventDefault();

    var tab = $(this).parents('.tab-pane');
    var list = $('ul.js-pet-tab-nav');

    list.find('li').first().find('a').trigger('click');
    list.find('li').first().find('a').trigger('focus');
    list.find('a[href*="#' + tab.attr('id') + '"]').parents('li.nav-item').addClass('d-none');

    setTimeout(function(){
      list.find('li').first().find('a').addClass('active');
    }, 200)

    var nonVisible = list.find('li.nav-item.d-none');

    tab.find('input, select, textarea').prop('disabled', true);

    if (nonVisible.length > 0) {
      $('.js-add-pet-tab').parents('li').show();
    }
  });

  $("body").on('click', '.js-pet-btn-group .btn', function(e){
    e.preventDefault();

    var button = $(this);
    var group = button.parents('.js-pet-btn-group');
    var nameField = group.find('.js-pet-name-field');
    var petId = group.find('.js-client-intake-response-pet-pet-id');

    var currentForm = button.closest('form');
    var currentTab = button.closest('.tab-pane');
    var enabledButtons = button.siblings('.btn:not(:disabled)');

    currentForm.find('.tab-pane').not(currentTab).each(function(){
      var tab = $(this);
      tab.find('.btn[data-id="' + button.data('id') + '"]').prop('disabled', true);

      enabledButtons.each(function() {
        tab.find('.btn[data-id="' + $(this).data('id') + '"]').prop('disabled', false);
      });
    });

    group.find('.btn').removeClass('active');
    
    setTimeout(function(){
      button.addClass('active');
    }, 50)

    if (button.hasClass('js-new-pet')) {
      petId.val('');
      nameField.val('');
      nameField.show();
    } else {
      petId.val(button.data('id'));
      nameField.hide();
      nameField.val(button.data('name'));
      nameField.trigger('change');
    }
  });
});
